export default __webpack_public_path__ + "static/media/right_arrow.f5e54238.svg";